import { render } from "./Header.AccountDropdownMenu.vue?vue&type=template&id=f63e6e22&scoped=true"
import script from "./Header.AccountDropdownMenu.vue?vue&type=script&lang=ts"
export * from "./Header.AccountDropdownMenu.vue?vue&type=script&lang=ts"

import "./Header.AccountDropdownMenu.vue?vue&type=style&index=0&id=f63e6e22&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f63e6e22"

export default script